<script>
    import { createEventDispatcher } from "svelte";

    export let flipped;
    export let titleImage;

    const dispatch = createEventDispatcher();
</script>

<div
    class="herve grid-container pCursor  {flipped ? 'flipped-grid' : 'flex-row'}"
    on:click={() => dispatch("click")}
>
    {#if !flipped}
        <div
            class="title-image imageBlur"
            class:flipped-image={flipped}
            style="background-image: url({titleImage})"
        />
        <div class={flipped ? "padded-reverse" : "padded"}>
            <slot name="content" />
        </div>
    {:else}
        <div class={flipped ? "padded-reverse" : "padded"}>
            <slot name="content" />
        </div>
        <div
            class="title-image imageBlur"
            class:flipped-image={flipped}
            style="background-image: url({titleImage})"
        />
    {/if}
    <div class={flipped ? "more-icon-flipped" : "more-icon"}>
        <slot name="more" />
    </div>
</div>

<style>
    .flex-row {
        flex-direction: column;
        align-content: start;
    }

    .grid-container {
        display: grid;
        min-width: 320px;
        max-width: 320px;
        grid-template-rows: 1fr auto;
        position: relative;
        overflow: hidden;
        height: 100%;
    }

    .flipped-grid {
        grid-template-rows: auto 1fr;
    }

    .flipped-image {
        align-self: end;
    }

    .title-image {
        aspect-ratio: 3/2;
        background-repeat: no-repeat;
        background-size: cover;
        background-position: center;
        align-self: flex-end;
    }

    .padded {
        margin-top: 16px;
    }

    .padded-reverse {
        margin-top: 0px;
    }

    .more-icon {
        position: absolute;
        bottom: 0px;
        right: 0px;
    }

    .more-icon-flipped {
        position: absolute;
        top: 8px;
        right: 0px;
    }

    @media only screen and (min-width: 800px) {
        .title-image {
            align-self: start;
        }

        .grid-container {
            max-width: 538px;
            width: 538px;
        }

        .flipped-image {
            align-self: end;
        }
    }
</style>
